<template>
  <nav role="navigation">
    <div id="container-logo" @click="menuAtivo = false">
      <router-link to="/">
        <ExceptionLogo
          :menuAtivo="menuAtivo"
          id="logo"
          :class="{ white: menuAtivo }"
          alt="exception jr logo"
        />
      </router-link>
    </div>

    <div id="desktop-menu">
      <ul id="desktop-menu-list">
        <li v-for="{ title, to } in menuLinks" :key="title" class="desktop-menu-item">
          <router-link :to="to" class="desktop-menu-link">{{ title }}</router-link>
        </li>
      </ul>
    </div>

    <div id="menuToggle">
      <!-- A lista dos links que é o menu de fato -->

      <input type="checkbox" id="checkMenu" v-model="menuAtivo" />

      <!-- Spans que se tornarão um hamburger -->
      <span></span>
      <span></span>
      <span></span>
      <div id="mobile-menu">
        <ul id="mobile-menu-list">
          <li
            v-for="{ title, to } in menuLinks"
            :key="title"
            class="mobile-menu-item"
            @click="menuAtivo = !menuAtivo"
          >
            <router-link :to="to" class="mobile-menu-link">{{ title }}</router-link>
          </li>
        </ul>
        <div id="mobile-menu-footer">
          <a
            id="contacts-email"
            class="mobile-menu-footer-link"
            :href="'mailto:' + contacts.email"
          >{{ contacts.email }}</a>
          <div id="contacts-telefone">
            <a
              :href="'tel:' + contacts.phone"
              :key="contacts.phone"
              class="mobile-menu-footer-link"
            >{{ contacts.phone }}</a>
          </div>
          <div id="contacts-redes-sociais-container">
            <a
              v-for="socialMedia in contacts.socialMedias"
              :key="socialMedia.name"
              :href="socialMedia.url"
              target="_blank"
              class="mobile-menu-footer-link"
            >
              <font-awesome-icon :icon="socialMedia.icon"></font-awesome-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import ExceptionLogo from "@/components/ExceptionLogo";

export default {
  name: "TheHeader",
  components: {
    ExceptionLogo
  },
  data() {
    return {
      menuAtivo: false
    };
  },
  computed: {
    contacts() {
      return this.$store.state.contacts;
    },
    menuLinks() {
      return this.$store.state.menuLinks;
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
nav {
  width: 90vw;
  height: 80px;
  margin: auto;
  @include flexbox(row, space-between);
  position: relative;

  /* ÍCONE DO MENU */
  #container-logo {
    @include flexbox(row, center, center);
    a {
      @include reset-css();
      z-index: 3;
      padding: 5px 0;
      position: relative;
      height: 70px;

      svg {
        height: 100%;
      }
    }
  }
  /* MENU DESKTOP OCULTO */
  #desktop-menu {
    display: none;
    @include for-tablet-landscape-up {
      display: flex;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    #desktop-menu-list {
      display: flex;
      justify-content: flex-end;
      list-style-type: none;
      // padding: 0 20px;
      margin: auto 0;

      .desktop-menu-link {
        font-size: 1rem;
        font-weight: 600;
        text-decoration: none;
        padding: 5px 5px;
        margin: 0 5px;
        transition: all 0.2s ease;
        color: $cor-primaria;
        // color: $verde-exception;
        &:hover,
        &.router-link-exact-active {
          color: $verde-exception;
          // border-bottom: 2px solid #248b3f;
        }
      }
    }
  }
  /* MENU MOBILE */
  #menuToggle {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    margin: auto 0px;
    @include for-tablet-portraid-up() {
      margin: auto -25px;
    }
    /* padding: 30px; */
    z-index: 1;
    -webkit-user-select: none;
    user-select: none;
    /* CHECKBOX */
    @include for-tablet-landscape-up {
      display: none;
    }

    input {
      margin: 0;
      display: flex;
      width: 40px;
      height: 32px;
      top: -3px;
      right: -3px;
      position: absolute;
      cursor: pointer;
      opacity: 0;
      z-index: 2;
      -webkit-touch-callout: none;
    }

    /* SPANS PARA FAZER O MENU HAMBURGER */
    span {
      display: flex;
      width: 35px;
      height: 4px;
      margin-bottom: 5px;
      position: relative;
      // background: $verde-exception;
      background: $degrade-exception;

      border-radius: 3px;
      z-index: 1;

      transform-origin: 5px 0;

      transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
        background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
    }
    /* CONFIGURAÇÕES DA ANIMAÇÃO DO MENU */
    span:first-child {
      transform-origin: 0% 0%;
    }

    span:nth-last-child(2) {
      transform-origin: 0% 100%;
    }

    input:checked ~ span {
      opacity: 1;
      transform: rotate(45deg) translate(-3px, -1px);
      background: #ffff;
    }

    input:checked ~ span:nth-last-child(3) {
      opacity: 0;
      transform: rotate(0deg) scale(0.2, 0.2);
    }

    input:checked ~ span:nth-last-child(2) {
      transform: rotate(-45deg) translate(0, -1px);
    }
    input:checked ~ #mobile-menu {
      transform: none;
    }
  }
  /* UL COM OS LINKS DO MENU */
  #mobile-menu {
    box-sizing: border-box;
    position: fixed;
    width: 105vw;
    height: 101vh;
    margin: -30px 0 0 20px;
    padding: 80px 0 50px 0;
    background: $verde-exception;
    transform: translate3d(100%, 0, 0);
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    #mobile-menu-list {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 0;
      list-style-type: none;
      @include for-tablet-portraid-up {
        flex: 1;
        flex-direction: row;
        width: 100%;
        justify-content: space-around;
        align-content: center;
        align-items: center;
        padding: 0 50px;
      }
      .mobile-menu-item {
        .mobile-menu-link {
          text-decoration: none;
          color: white;
          opacity: 1;
          font-size: 1.5rem;
          font-weight: 500;
          transition: 200ms;
          @include for-tablet-portraid-up {
            // font-size: 4vw;
          }
        }
      }
    }
    #mobile-menu-footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      @include for-tablet-portraid-up {
        box-sizing: border-box;
        flex-direction: row;
        align-self: flex-end;
      }
      a {
        @include for-tablet-portraid-up {
          margin-right: 20px;
        }
      }
      .mobile-menu-footer-link {
        text-decoration: none;
        font-size: 1rem;
        color: white;
        padding: 5px 0 5px 0;
        @include for-tablet-portraid-up {
          // font-size: 1;
        }
      }
      #contacts-redes-sociais-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        @include for-tablet-portraid-up {
          width: auto;
        }
        a {
          font-size: 1.5rem;
          margin: 0 10px;
          @include for-tablet-portraid-up {
            // font-size: 4vw;
          }
        }
      }
    }
  }
}

// @media screen and (min-width: 900px) {
//   #desktop-menu-list {
//     display: flex;
//     justify-content: flex-end;
//     list-style-type: none;
//     padding: 0 20px;
//     margin: auto 0;
//   }

//   .desktop-menu-link {
//     font-size: 1rem;
//     font-weight: 500;
//     text-decoration: none;
//     padding: 5px 5px;
//     margin: 0 5px;
//     transition: all 0.2s ease;
//   }

// }
</style>
